let showErrorGlobal;

export const registerErrorHandler = (fn) => {
	showErrorGlobal = fn;
};

export const errorHandler = (message) => {
	if (showErrorGlobal) {
		showErrorGlobal(message);
	} else {
		console.error("Global error:", message);
	}
};
